export const FETCH_OWNED_DATASPACES = 'FETCH_OWNED_DATASPACES';
export const FETCH_PARTICIPANT_DET = 'FETCH_PARTICIPANT_DET';
export const FETCH_SERVICE_OVERVIEW = 'FETCH_SERVICE_OVERVIEW';
export const FETCH_DATASPACE_DETAILS = 'FETCH_DATASPACE_DETAILS';
export const FETCH_APPLICATION_DATA = 'FETCH_APPLICATION_DATA';
export const REGISTER_APPLICATION = 'REGISTER_APPLICATION';
